import wx from "weixin-js-sdk";
const axios = require('axios').default;

export default {
    //判断是否在微信中
    isWechat: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/micromessenger/i) == 'micromessenger') {
            console.log('是微信客户端')
            return true;
        } else {
            console.log('不是微信客户端')
            return false;
        }
    },

    //判断是否在企业微信中  
    isWxwork: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/wxwork/i) == 'wxwork') {
            console.log('是企业微信端')
            return true;
        } else {
            console.log('不是企业微信客户端')
            return false;
        }
    },


    browser: function () { // 获取浏览器UA标识
        var u = navigator.userAgent;

        console.log(u)
        // Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.131 Safari/537.36
        return {
            trident: u.indexOf('Trident') > -1, // IE内核
            presto: u.indexOf('Presto') > -1, // opera内核
            webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
            iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, // 是否iPad
            webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, // 是否微信
            qq: u.match(/\sQQ/i) === ' qq', // 是否QQ

            alipay: u.indexOf('AlipayClient') > -1, //是否支付宝
            HeyTap: u.indexOf('HeyTapBrowser') > -1, //是否HeyTap
            VivoBrowser: u.indexOf('VivoBrowser') > -1, //是否vivo
            MQQBrowser: u.indexOf('MQQBrowser') > -1, //是否QQ浏览器移动版
            QQBrowser: u.indexOf('QQBrowser') > -1, //是否QQ浏览器
            baiduboxapp: u.indexOf('baiduboxapp') > -1, //是否百度app
            Weibo: u.indexOf('Weibo') > -1, //是否新浪微博
            iqiyi: u.indexOf('iqiyi') > -1, //是否爱奇艺
            aweme: u.indexOf('aweme') > -1, //是否抖音
            kdtUnion_iting: u.indexOf('kdtUnion_iting') > -1, //是否喜马拉雅
            DingTalk: u.indexOf('DingTalk') > -1, //是否钉钉
            UCBrowser: u.indexOf('UCBrowser') > -1, //是否UC浏览器
            SamsungBrowser: u.indexOf('SamsungBrowser') > -1, //是否三星浏览器
            HUAWEIEVA: u.indexOf('HUAWEIEVA') > -1, //是否华为浏览器
            NokiaBrowser: u.indexOf('NokiaBrowser') > -1, //是否诺基亚浏览器
            Opera: u.indexOf('Opera') > -1, //是否欧朋
            // Firefox: u.indexOf('Firefox') > -1, //是否火狐
            // Chrome: u.indexOf('Chrome') > -1, //是否谷歌
            // Safari: u.indexOf('Safari') > -1, //是否苹果
        };
    },


    getBrowser(){
        var u = window.navigator.userAgent;

        if (/MicroMessenger/.test(u)) {
            return('WeChat(微信)');
        }else if(/AlipayClient/.test(u)) {
            return('Alipay(支付宝)');
        }else if(/QQTheme/.test(u)) {
            return('QQ');
        }else if(/HeyTapBrowser/.test(u)) {
            return('HeyTapBrowser(HeyTap)');
        }else if(/VivoBrowser/.test(u)) {
            return('VivoBrowser(vivo)');
        }else if(/MQQBrowser/.test(u)) {
            return('MQQBrowser(QQ浏览器移动版)');
        }else if(/QQBrowser/.test(u)) {
            return('QQBrowser(QQ浏览器)');
        }else if(/baiduboxapp/.test(u)) {
            return('baiduboxapp(百度app)');
        }else if(/Weibo/.test(u)) {
            return('Weibo(新浪微博)');
        }else if(/iqiyi/.test(u)) {
            return('iqiyi(爱奇艺)');
        }else if(/aweme/.test(u)) {
            return('aweme(抖音)');
        }else if(/kdtUnion_iting/.test(u)) {
            return('kdtUnion_iting(喜马拉雅)');
        }else if(/DingTalk/.test(u)) {
            return('DingTalk(钉钉)');
        }else if(/UCBrowser/.test(u)) {
            return('UCBrowser(UC浏览器)');
        }else if(/SamsungBrowser/.test(u)) {
            return('SamsungBrowser(三星浏览器)');
        }else if(/HUAWEIEVA/.test(u)) {
            return('huaweiBrowser(华为浏览器)');
        }else if(/NokiaBrowser/.test(u)) {
            return('NokiaBrowser(诺基亚浏览器)');
        }else if(/Opera/.test(u)) {
            return('Opera(欧朋)');
        }else if(/Firefox/.test(u)) {
            return('Firefox(火狐)');
        }else if(/Chrome/.test(u)) {
            return('Chrome(谷歌)');
        }else if(/Safari/.test(u)) {
            return('Safari(苹果)');
        }else{
            return('other');
        }

    },

    // 判断时间是否在某个区间值内
    checkAuditTime(beginTime, endTime) {
        var nowDate = new Date();
        var beginDate = new Date(beginTime);
        var endDate = new Date(endTime);

        console.log(nowDate, beginDate, endDate)
        console.log(nowDate.getTime(), beginDate.getTime(), endDate.getTime())
        console.log(nowDate.getTime() >= beginDate.getTime())
        console.log(nowDate.getTime() <= endDate.getTime())
        // debugger
        if (nowDate.getTime() >= beginDate.getTime() && nowDate.getTime() <= endDate.getTime()) {
            return true;
        } else {
            return false;
        }
    },


    // js-sdk初始化
    initJssdk(callback) {
        axios({
            url:'https://beingmate-scrm-v1.beingmate.com/api/openweixin/login/js_sdkinit',
            params: {
				nick_name:"贝因美官方号",
                wx_url: window.location.href.split('#')[0]
            }, //向服务端提供授权url参数，并且不需要#后面的部分
            //注意：这个url必须是小程序进入webview的地址，并且是合法域名形式地址！这样获取的数据才能保证签名没问题
        }).then((res) => {

            let d = res.data.data;
            console.log(d)
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.data.appid, // 必填，公众号的唯一标识
                timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
                signature: res.data.data.signature, // 必填，签名
                jsApiList: [
                    "checkJsApi",
                    "getLocation",
                    "openLocation",
                    "hideAllNonBaseMenuItem", //隐藏所有非基础按钮接口
                    "showAllNonBaseMenuItem",
                    "scanQRCode",
                    "previewImage",
                ], // 必填，需要使用的JS接口列表
                openTagList: ["wx-open-launch-weapp"], // 打开小程序
            });

            wx.ready(function () {
                // return("ready");
                // 在这里调用 API
                //判断当前客户端版本是否支持指定JS接口
                wx.checkJsApi({
                    jsApiList: [
                        // 所有要调用的 API 都要加到这个列表中
                        "scanQRCode",
                        "previewImage",
                        "getLocation",
                        "openLocation"
                    ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function (res) {
                        console.log("checkJsApi成功=====", res);

                        if (callback) {
                            callback();
                        }
                        // 以键值对的形式返回，可用的api值true，不可用为false
                        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                    },
                    fail: function (e) {
                        return(e, "不支持");
                    },
                });
            });
            wx.error(function (res) {
                // wx.config注册失败就会执行
                return(res, "error");
            });
        });
    },


    // 在需要定位页面调用
    location: function () {
        if (!this.isWechat()) {
            return;
        }
        console.info('定位')

       
        return  new Promise(resolve => {
            this.initJssdk( () => {
                wx.getLocation({
                    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    // success: function (res) {
                    //     console.log(res);
                    //     cbSuccess(res)
                    // },
                    // fail: function (res) {
                    //     console.log(res)
                    //     if (cbFail) {
                    //         cbFail(res)
                    //     }
                    // },
                    // cancel: function (res) {
                    //     console.log(res)
                    //     if (cbFail) {
                    //         cbFail(res)
                    //     }
                    // },
                    complete:(res)=>{
                        console.log(res)
                        // callbackRes(res)
                       resolve(res)
                    }
                });
            });
        })

        
    },

    openLocation(location) {
        if (!this.isWechat()) {
            return;
        }
        this.initJssdk(() => {
            wx.openLocation(location)
        })
    },


    // 扫码
    scanQRCode: function (callback) {
        if (!this.isWechat()) {
            console.log('不是微信客户端')
            return;
        }
        this.initJssdk(function () {
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    callback(res) // 当needResult 为 1 时，扫码返回的结果
                },
                fail: function (res) {
                    return("扫码失败")
                }
                // complete:function(res){
                //     console.log(res)
                // }
            });
        });
    },

}